const SVG = ({ fill = "#B69B64", width = "14", height = "14", viewBox = "0 0 14 14" }) => (
  <svg fill="none" width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.25766 0.600098C1.60081 0.600098 0.25766 1.94325 0.25766 3.6001V10.4001C0.25766 12.057 1.60081 13.4001 3.25766 13.4001H10.0577C11.7145 13.4001 13.0577 12.0569 13.0577 10.4001V3.6001C13.0577 1.94324 11.7145 0.600098 10.0577 0.600098H3.25766ZM8.79099 3.8C8.79099 3.2109 9.26855 2.73333 9.85765 2.73333C10.4468 2.73333 10.9243 3.2109 10.9243 3.8C10.9243 4.3891 10.4468 4.86667 9.85765 4.86667C9.26855 4.86667 8.79099 4.3891 8.79099 3.8ZM4.09724 7.00063C4.09724 5.58678 5.24339 4.44062 6.65724 4.44062C8.07109 4.44062 9.21724 5.58678 9.21724 7.00063C9.21724 8.41447 8.07109 9.56063 6.65724 9.56063C5.24339 9.56063 4.09724 8.41447 4.09724 7.00063Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
